module.exports = __webpack_public_path__ + "static/img/BN.13b1bf61.svg";